import { MutationDocuments, QueryDocuments } from './graphql.schemas';
export function getMutation(mutationName) {
    return MutationDocuments[mutationName];
}
export function getQuery(queryName) {
    return QueryDocuments[queryName];
}
